import Vue from 'vue'
import Router from 'vue-router'
import BasicLayout from '@/views/Layout/BasicLayout'
import Home from '@/views/home/'
import Faq from '@/views/faq/index.vue'
import Browse from '@/views/browse/'
import Beer from '@/views/beer/'
import Contact from '@/views/contact/'
import Profile from '@/views/profile/'
import Orders from '@/views/orders/'
import Orderdetails from '@/views/orders/orderdetails'
import Login from '@/views/login/index.vue'
import Promotions from '@/views/promotions/'
import Cart from '@/views/cart/'
import Confirmation from '@/views/cart/confirmation'
import Successful from '@/views/cart/successful'
import Error404 from '@/views/error/404'

Vue.use(Router)

const VueRouter = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition)
        }, 1500)
      })
      // console.log('savedPosition', savedPosition)
      // return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: BasicLayout,
      redirect: '/home',
      children: [
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/home',
          name: 'Home',
          component: Home
        },
        {
          path: '/faq',
          name: 'Faq',
          component: Faq
        },
        // {
        //   path: '/browse',
        //   name: 'Browse',
        //   component: Browse,
        //   meta: {
        //     roles: ['unknown']
        //   }
        // },
        {
          path: '/browse',
          name: 'Browse',
          component: Browse,
          props: (route) => ({
            id: route.query.id,
            breweryId: route.query.breweryId,
            styleId: route.query.styleId,
            region: route.query.region,
            keg: route.query.keg,
            bottle: route.query.bottle,
            core: route.query.core,
            page: route.query.page,
            search: route.query.search
          }),
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/beer',
          name: 'Beer',
          component: Beer,
          props: (route) => ({
            id: route.query.id,
            name: route.query.name,
            breweryId: route.query.breweryId,
            styleId: route.query.styleId
          }),
          meta: {
            roles: ['unknown']
          }
        },
        // {
        //   path: '/promotions',
        //   name: 'Promotions',
        //   component: Promotions,
        //   meta: {
        //     roles: ['unknown']
        //   }
        // },
        {
          path: '/promotions/:id',
          name: 'Promotions',
          component: Promotions,
          props: true,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/cart',
          name: 'Cart',
          component: Cart,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/cart/confirmation',
          name: 'Confirmation',
          component: Confirmation,
          props: true,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/cart/successful',
          name: 'Successful',
          component: Successful,
          props: true,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/profile',
          name: 'Profile',
          component: Profile,
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/profile/orders',
          name: 'Orders',
          component: Orders,
          props: (route) => ({
            page: route.query.page
          }),
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '/profile/orders/details',
          name: 'Orderdetails',
          component: Orderdetails,
          props: (route) => ({
            id: route.query.id
          }),
          meta: {
            roles: ['unknown']
          }
        },
        {
          path: '*',
          name: '404',
          component: Error404,
          meta: {
            roles: ['unknown']
          }
        }
      ]
    }
  ]
})

export default VueRouter



// WEBPACK FOOTER //
// ./src/router/index.js